import { LoadingWarren } from '@simplywallst/ui-core';

// TODO: this is temporary, will update with a skeleton like table once the pagee loayout is done
export const LoadingState = () => {
  return (
    <div className="grid h-screen place-items-center">
      <LoadingWarren />
    </div>
  );
};
